import { ConsolidatedTransactionDetailsProviderState, TransactionDocumentsDataSetter } from './types';

const defaultConsolidatedTransactionDetailsProviderState: ConsolidatedTransactionDetailsProviderState = {
  checkAuthorizationData: null,
  consolidatedTransactionDetails: null,
  selectedConsolidatedTransaction: null,
  getTransactionDocuments: (orderId: number, dataSetter: TransactionDocumentsDataSetter) => {},
  getSingleFileDocumentData: (fileSn: number, referenceNumber: string) => {},
  onCheckAuthorizationMutation: () => {},
  onSelectConsolidatedTransaction: (transactionNo?: string) => {},
  resetSelectedConsolidatedTransaction: () => {},
  refetchConsolidatedTransactionDetails: () => {},
  loadingState: {
    isLoadingConsolidatedTransactionDetails: false,
    isLoadingCheckAuthorization: false,
  },
  errorState: {
    consolidatedTransactionDetailsError: undefined,
    checkAuthorizationError: undefined,
  },
};

export { defaultConsolidatedTransactionDetailsProviderState };
